import { styled } from "@mui/material/styles";
import { BORDER, COLOR_GREY_6 } from "shared/theme/colors";
import Box from "@mui/material/Box";

export const StyledDetailsContainer = styled(Box)`
  border: ${BORDER(1, COLOR_GREY_6)};
  border-radius: 1rem;
`;
